import { CollectionExpressionEntry, formatIsbdTitle } from "@biblioteksentralen/cordata";
import { Box, colors, HStack, Text, TextProps, VStack } from "@biblioteksentralen/react";
import { getPath } from "@libry-content/common";
import { unique } from "radash";
import InternalLink from "../../components/InternalLink";
import { useTranslation } from "../../utils/hooks/useTranslation";
import {
  collectionExpressionEntryHasWork,
  collectionExpressionEntryIsNotFictionalUniverse,
} from "../cordata/collections";

type CollectionsProps = TextProps & { collections: CollectionExpressionEntry[] | undefined };

export const Collections = ({ collections, ...textProps }: CollectionsProps) => {
  const { t } = useTranslation();
  const collectionsWithWork = collections
    ?.filter(collectionExpressionEntryHasWork)
    .filter(collectionExpressionEntryIsNotFictionalUniverse);

  if (!collectionsWithWork?.length) return null;
  const uniqueCollections = unique(collectionsWithWork, (entry) => entry.collection.workExpressed?.id);

  return (
    <VStack gap="0" alignItems="flex-start">
      {uniqueCollections.map((collectionExpressionWithWork) => (
        <Box maxWidth="100%" key={collectionExpressionWithWork.collection.workExpressed?.id} {...textProps}>
          <HStack gap="0" flexWrap="wrap">
            <Text color={colors.grey60}>
              {t("Del {nummer} av", { nummer: collectionExpressionWithWork.numberInSeries ?? "" })}
            </Text>
            <InternalLink display="inline" marginLeft=".25em" href={getPath(collectionExpressionWithWork.collection)}>
              {formatIsbdTitle(collectionExpressionWithWork.collection)}
            </InternalLink>
          </HStack>
        </Box>
      ))}
    </VStack>
  );
};
